<template>
  <div>
    <div v-if="metadata != null">
      <gerdau-crud-meta-view
        :service="service"
        :metadata="metadata"
        translatePrefix="application.pages"
      />
    </div>
    <div class="import-data">
      <ImportData
        :service="driverService"
        :templateUrl="templateName"
        :templateName="name"
        @update-table="refreshTable"
      />
    </div>
  </div>
</template>

<script>
import { GerdauCrudMetaView } from '../components/crud/index'
import { ImportData } from '../components/importData/index'
import helpers from '../helpers/findComponent'
import { CrudAction } from '@brain/core'
import { driverService } from '../services'
import { handleError } from '../helpers'

export default {
  name: 'Driver',
  components: {
    GerdauCrudMetaView,
    ImportData
  },
  data: () => ({
    service: {
      ...driverService
    },
    driverService,
    metadata: null,
    name: 'driver',
    nameTemplate: ''
  }),
  methods: {
    async refreshTable() {
      let bcGrid = helpers.findComponent(this, 'BcGrid')
      const [data] = await Promise.all([this.service.getAll()])
      bcGrid.aggridApi.setRowData(data)
    },
    async getMeta() {
      const meta = await driverService.getMetaWithValidation()
      meta.permissions = [
        CrudAction.UPDATE,
        CrudAction.CREATE,
        CrudAction.EXPORT
      ]
      meta.fields.forEach((field) => {
        if (field.id === 'cpf') {
          field.target = ['form']
        }
      })
      return meta
    }
  },
  created() {
    this.templateName = `./${this.name}.xlsx`
    this.service.getAll = async () => {
      try {
        return await driverService.getDriversByUserCompany()
      } catch (e) {
        handleError(e)
      }
    }
    this.service.export = async () => {
      try {
        return await driverService.getExportVehicleByUserCompany()
      } catch (e) {
        handleError(e)
      }
    }
    this.getMeta().then((meta) => {
      this.metadata = meta
    })
  }
}
</script>
<style lang="scss" scoped></style>
